import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatRelative } from "../lib/api";
import Layout from "../components/Layout";
import { useAuth } from "../contexts/AuthContext";
import { Pin, Lock, MessageSquare, Bookmark, MessageCircle, Edit3 } from "lucide-react";

const TABS = [
  { k: "started",       label: "Mine tråder",     Icon: Edit3 },
  { k: "participating", label: "Deltar i",        Icon: MessageCircle },
  { k: "bookmarked",    label: "Bokmerker",       Icon: Bookmark },
];

export default function MineTrader() {
  const { user } = useAuth();
  const [tab, setTab] = useState("started");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || user === false) return;
    setLoading(true);
    api.get(`/threads/mine?view=${tab}`)
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  }, [tab, user]);

  if (user === false || user === null) {
    return (
      <Layout>
        <div className="font-fraunces italic text-[var(--cream-soft)]">
          <Link to="/login" className="text-[var(--magenta)]">Logg inn</Link> for å se dine tråder.
        </div>
      </Layout>
    );
  }

  return (
    <Layout withSidebar={false}>
      <div className="font-meta mb-3">Forum</div>
      <h1 className="font-fraunces italic text-5xl text-[var(--cream)] leading-tight mb-10">
        Dine tråder.
      </h1>

      <div className="flex gap-6 border-b border-white/10 mb-8" data-testid="mine-tabs">
        {TABS.map((t) => (
          <button
            key={t.k}
            onClick={() => setTab(t.k)}
            data-testid={`mine-tab-${t.k}`}
            className={`pb-3 font-manrope text-[11px] uppercase tracking-[0.25em] transition-colors relative inline-flex items-center gap-2 ${
              tab === t.k ? "text-[var(--cream)]" : "text-[var(--cream-soft)] hover:text-[var(--cream)]"
            }`}
          >
            <t.Icon className="h-3 w-3" /> {t.label}
            {tab === t.k && <span className="absolute left-0 right-0 -bottom-px h-px bg-[var(--magenta)]" />}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="font-meta text-[var(--cream-soft)]">Laster…</div>
      ) : items.length === 0 ? (
        <div className="font-fraunces italic text-[var(--cream-soft)] py-12">
          {tab === "started" && (
            <>Du har ikke startet noen tråder enda. <Link to="/forum" className="text-[var(--magenta)]">Start din første tråd →</Link></>
          )}
          {tab === "participating" && (
            <>Du har ikke svart i andres tråder enda. <Link to="/forum" className="text-[var(--magenta)]">Bla i forum →</Link></>
          )}
          {tab === "bookmarked" && (
            <>Du har ikke bokmerket noen tråder. <Link to="/forum" className="text-[var(--magenta)]">Bla i forum →</Link></>
          )}
        </div>
      ) : (
        <ul className="divide-y divide-white/5" data-testid="mine-thread-list">
          {items.map((t) => (
            <li key={t.id}>
              <Link to={`/thread/${t.id}`} className="grid grid-cols-12 gap-4 py-5 items-center">
                <div className="col-span-12 sm:col-span-9">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    {t.is_pinned && <Pin className="h-3 w-3 text-[var(--magenta)]" />}
                    {t.is_locked && <Lock className="h-3 w-3 text-[var(--cream-faint)]" />}
                  </div>
                  <h3 className="font-fraunces italic text-xl text-[var(--cream)] leading-tight">{t.title}</h3>
                  <div className="font-meta mt-2">
                    {t.post_count} innlegg · sist {formatRelative(t.last_post_at)}
                  </div>
                </div>
                <div className="hidden sm:block col-span-3 text-right font-meta">
                  <MessageSquare className="h-3 w-3 inline mr-1.5" /> {t.post_count}
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </Layout>
  );
}
